import { useCallback } from 'react';
import { StyledButton } from '../ImageViewer.style';
import { MeasurementOutlined } from '../Icons/MeasurementIcon';

type MeasureProps = {
  onChange: (data: any) => void;
  value?: boolean;
  disabled?: boolean;
  hasHomography: boolean;
};

export const Measurement: React.FunctionComponent<MeasureProps> = ({
  onChange,
  value = false,
  disabled = false,
  hasHomography,
}) => {
  const handleClick = useCallback(() => {
    onChange({ measure: !value });
  }, [value, onChange]);

  return hasHomography ? (
    <StyledButton
      data-testid="image-controls-measure"
      title="Measurement tool"
      type={value ? 'primary' : 'default'}
      onClick={handleClick}
      disabled={disabled}
      icon={<MeasurementOutlined />}
    />
  ) : (
    <StyledButton
      data-testid="image-controls-measure"
      title={`This inspection does not have the metadata \nnecessary to calculate measurements`}
      disabled={true}
      icon={<MeasurementOutlined />}
    />
  );
};
